import Vue from 'vue';
import { orderService } from '../services/order.service';
import eventbus from '../../eventbus';

const state = {
  cart: null,
  orders: []
};

const actions = {

  /**
   * Retrieve the cart and put it in the vuex store.
   * @param state
   * @param commit
   * @returns {Promise<Response>}
   */
  async getCart({ state, commit }) {
    const cart = await orderService.getCart();
    commit('setCart', cart);
    return cart;
  },

  /**
   * Retrieve the orders if user was logged-in.
   * @param state
   * @param commit
   * @returns {Promise<Response>}
   */
  async getOrders({ state, commit }) {
    const orders = await orderService.getOrders();
    commit('setOrders', orders);
    return orders;
  },

  /**
   * Process the cart.
   * @param state
   * @param commit
   * @param email - Email used for non member user.
   * @returns {Promise<Response>}
   */
  async processCart({ state, commit }) {
    return orderService.processCart();
  },

  /**
   * Upsert a product.
   * @param state
   * @param commit
   * @param productId
   * @param quantity
   * @returns {Promise<Response>}
   */
  async upsertProduct({ state, commit }, { productId, quantity = 1 }) {
    const cart = await orderService.upsertProduct(productId, quantity);
    commit('setCart', cart);
    eventbus.$emit('cart-updated');
    return cart;
  },

  /**
   * Remove the product
   * @param state
   * @param commit
   * @param productId
   * @returns {Promise<Response>}
   */
  async removeProduct({ state, commit }, productId) {
    const cart = await orderService.removeProduct(productId);
    commit('setCart', cart);
    eventbus.$emit('cart-updated');
    return cart;
  },

  /**
   * Edit donation
   * @param state
   * @param commit
   * @param dispatch
   * @param amount
   * @param email
   * @param donor
   * @param name
   * @param paymentMethod
   * @returns {Promise<Response>}
   */
  async payDonation({ state, commit, dispatch }, { amount, email, donor, name, paymentMethod }) {
    return orderService.payDonation({ amount, email, donor, name, paymentMethod });
  },

  /**
   * Add / Update registration
   * @param state
   * @param commit
   * @param registrationId
   * @param type
   * @param memberId
   * @returns {Promise<Response>}
   */
  async upsertRegistration({ state, commit }, { registrationId, type, memberId }) {
    const cart = await orderService.upsertRegistration(registrationId, type, memberId);
    commit('setCart', cart);
    eventbus.$emit('cart-updated');
    return cart;
  },

  /**
   * Remove a registration.
   * @param state
   * @param commit
   * @param registrationId
   * @param type
   * @param memberId
   * @returns {Promise<Response>}
   */
  async removeRegistration({ state, commit }, { registrationId, type, memberId }) {
    const cart = await orderService.removeRegistration(registrationId, type, memberId);
    commit('setCart', cart);
    eventbus.$emit('cart-updated');
    return cart;
  }

};

const getters = {
  cart: state => {
    return state.cart;
  }
};

const mutations = {

  setCart(state, cart) {
    Vue.set(state, 'cart', cart);
  },

  setOrders(state, orders) {
    Vue.set(state, 'orders', orders);
  }

};

export const orders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
